export default {
  doneMaterials: [],
  currentLevel: 0,
  allRrData: {}
};
